<template>
  <div class="container">

    <div class="mt-4 mb-2 d-flex justify-content-between">
      <back-arrow :params="{operationId: operationId}" :title="$t('Operation.tasks')" routeBack="OperationShow" :sub-title-ope="this.operationName"/>
      <div class="row mx-0 ml-auto align-items-center">
        <b-button v-if="allowCreate" class="btn-medium" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a.e') }} {{ $t('operationTask') }}
        </b-button>
      </div>
    </div>

    <div v-if="!isLoading">
      <div class="mt-4 border-grey">
        <b122-table
          ref="B122TableOperationTask"
          :delete-item="allowDelete"
          :edit-item="allowEdit"
          :empty-button="$t('operationTask.emptyButton').toString()"
          :empty-text="$t('operationTask.emptyText').toString()"
          :empty-title="$t('operationTask.emptyTitle').toString()"
          :fields="tableFields"
          :get-b122-table-results-url="'/operationTask/getB122TableResults?restrictbylong-operationId=' + operationId"
          :use-filters="false"
          :use-pagination="false"
          identifier="B122TableOperationTask"
          init-b122-table-url="/operationTask/initB122Table"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnShowBtn="clickOnShowBtn"
          @setTotalCount="setTotalCount">

          <template #cell(status)="data">
            <b-form-select
              id="statut-input"
              v-model="data.item.status.value"
              :style="{borderColor: getColor(data.item.status.mainColor), backgroundColor: getColor(data.item.status.secondaryColor) }"
              class="bold-text main-color-text"
              required
              size="sm"
              style="max-width: 15vw;"
              v-on:change="saveStatusTask(data.item.id, data.item.status.value)">
              <option v-for="status in statusTask" :value="status.value">
                {{ $t(status.text) }}
              </option>
            </b-form-select>
          </template>
        </b122-table>
      </div>

      <Item-delete-modal
        id="task-delete-modal"
        :beginsWithVoyel="false"
        :isFeminine="false"
        :selectedItem="selectedTask"
        controllerName="operationTask"
        itemSingularName="tâche"
        itemSingularNameUpp="Tâche"
        @didDeleteItem="didDeleteTask()">
      </Item-delete-modal>
    </div>
  </div>
</template>

<script>

import B122Table from "../../../components/b122/B122Table";
import ItemDeleteModal from "../../../components/b122/ItemDeleteModal";
import api from "../../../services/api";
import BackArrow from "../../../components/b122/BackArrow.vue";

export default {
  name: "OperationShowTasks",

  components: {
    BackArrow,
    B122Table,
    ItemDeleteModal
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      isLoading: false,
      totalCount: 0,

      statusTask: [],

      allowCreate: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      allowEdit: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      allowDelete: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      operationName: null,
      selectedTask: null
    }
  },

  computed: {
    tableFields() {
      let tableFields = [
        {
          label: this.$t('See'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$t('OperationTask.name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$t('OperationTask.deadlineDate'),
          key: 'deadlineDate',
          sortable: true,
          formatter: function (value) {
            return new Date(value).toLocaleDateString()
          }
        },
        {
          label: this.$t('OperationTask.status'),
          key: 'status',
          sortable: true
        },
        {
          label: this.$t('OperationTask.assignedTo'),
          key: 'assignedToString',
          sortable: true
        },
        {
          label: '',
          key: 'actions'
        }]
      return tableFields
    }
  },

  async mounted() {
    await this.getStatusTask()
    if(this.operationId){
      await this.fetchOperation()
    }
  },

  emits: ['refreshAlerts'],

  methods: {
    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operationName = response.data.name
        })
    },

    async getStatusTask() {
      this.isLoading = true
      await api
        .get(`/operationTask/getStatusTask`)
        .then(response => {
          this.statusTask = response.data
          this.isLoading = false
        })

    },

    getColor(color) {
      return color.toString()
    },

    saveStatusTask(id, status) {
      let data = new FormData()
      data.append('status', status)
      let url = '/operationTask/updateStatus/' + id

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(() => {
          this.$refs.B122TableOperationTask.refreshTable()
          this.$emit('refreshAlerts')
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },


    clickOnCreateBtn() {
      this.$router.push({
        name: 'OperationTaskCreateEdit',
        params: {
          fromDashboard: false,
          operationTaskId: null,
          operationId: this.operationId
        }
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'OperationTaskShow',
        params: {
          operationId: this.operationId,
          operationTaskId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'OperationTaskCreateEdit',
        params: {
          fromDashboard: false,
          operationTaskId: row.item.id,
          operationId: this.operationId
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.selectedTask = row.item
      this.$bvModal.show('task-delete-modal')
    },

    didDeleteTask() {
      this.selectedTask = null
      this.$refs.B122TableOperationTask.refreshTable()
      this.$emit('refreshAlerts')
    },
  }
}
</script>

<style scoped>
.border-grey {
  border: 1px solid var(--main-grey);
  padding: 15px;
  background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowTasks.vue